export const ACTIVE_NOT_ACK = 'active-not-ack' as const;
export const ACTIVE_ACK = 'active-ack' as const;
export const NOT_ACTIVE_NOT_ACK = 'not-active-not-ack' as const;

export const BUREAU_CATEGORY_LABELS = {
  all: 'All',
  'active-not-ack': 'Active (Unacknowledged)',
  'active-ack': 'Active (Acknowledged)',
  'not-active-not-ack': 'Inactive (Unacknowledged)',
} as const;

export type BureauCategoryKey = keyof typeof BUREAU_CATEGORY_LABELS;

export function getBureauCategoryLabel(key: string) {
  if ((key as BureauCategoryKey) in BUREAU_CATEGORY_LABELS) {
    return BUREAU_CATEGORY_LABELS[key as BureauCategoryKey];
  }
  return key.replaceAll('-', ' ');
}
